import { TaskType } from '../../task-types/task-main.js';

export interface ExtractionRegion {
  taskPath: string[];
  taskType: string;
  pageNumber: number;
  bbox: { x1: number; y1: number; x2: number; y2: number };
  confidence?: number;
}

interface ParsedTask {
  taskNumber?: string;
  taskType?: string;
  subtasks?: ParsedTask[];
  boundingBoxes?: Array<{
    bbox?: { x1: number; y1: number; x2: number; y2: number };
    pageNumber?: number;
    confidence?: number;
  }>;
}

export function mapParsedTasksToRegions(parsed: any): ExtractionRegion[] {
  if (!parsed?.tasks || !Array.isArray(parsed.tasks)) return [];

  const regions: ExtractionRegion[] = [];

  const walk = (nodes: ParsedTask[], path: string[]) => {
    for (const node of nodes) {
      const taskNumber = String(node?.taskNumber ?? '').trim();
      if (!taskNumber) continue;

      const currentPath = [...path, taskNumber];
      const boxes = Array.isArray(node?.boundingBoxes) ? node.boundingBoxes : [];

      for (const region of boxes) {
        if (!region?.bbox || typeof region.pageNumber !== 'number') continue;
        regions.push({
          taskPath: currentPath,
          taskType: node?.taskType || TaskType.DEFAULT,
          bbox: region.bbox,
          pageNumber: region.pageNumber,
          confidence: typeof region.confidence === 'number' ? region.confidence : undefined,
        });
      }

      if (Array.isArray(node?.subtasks) && node.subtasks.length > 0) {
        walk(node.subtasks, currentPath);
      }
    }
  };

  walk(parsed.tasks as ParsedTask[], []);
  return regions;
}
